<template>
  <div class="container">
    <!-- Header -->
    <Header></Header>
    <div class="head-img">
      <img :src="headImg">
    </div>
    <!-- 主内容 -->
    <div class="aboutboxxq">
      <h2>现招职位</h2>
      <div class="common-border"></div>
      <div class="content-join">
        <div class="about_adv">
          <span class="headcate">
            <code :class="[type == 1?'aboutnow':'']" @click="changeType(1)">校园招聘</code>
            <code :class="[type == 2?'aboutnow':'']" @click="changeType(2)">社会招聘</code>
            <code :class="[type == 3?'aboutnow':'']" @click="changeType(3)">实习生招聘</code>
          </span>
          <div class="recruit-container">
            <div class="recruit-left">
              <div class="left-cate" v-for="(item,index) in cateInfo " :key="index" :data-id="item.id" :data-index="index" @click="changeCate($event)" :class="{'is-on':index ==cateIndex}">
                <i class="iconfont">&#xe606;</i>
                <span class="catename" :data-id="item.id" :data-index="index" @click="changeCate($event)">{{item.catename}}</span>
              </div>
            </div>
            <div class="recruit-right">
              <div class="right-cate" v-for="(item,index) in positionInfo " :key="index" :class="{'is-cate':item.cateid == itemIndex|| itemIndex == 0}" >
                <div class="right-cate-head">
                  <div class="head-left" :class="{'is-open':index == showcontent}">
                    <i class="iconfont">&#xe63b;</i>
                    <span>{{item.name}}</span>
                  </div>
                  <div class="head-right">
                    <div class="iconfont">&#xe6b3;</div>
                    <span>{{item.city}}</span>
                    <div class="icon">
                      <i class="iconfont is-show"  :data-index="index" :data-id="item.id" @click="changicon($event)">&#xe73d;</i>
                      <i class="iconfont" :data-index="index" :data-id="item.id" @click="changicon($event)">&#xe73a;</i>
                    </div>
                  </div>
                </div>
                <div class="right-cate-content" :class="{'is-show':index == showcontent}" v-html="item.jobInfo">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <Footer></Footer>
 </div>
</template>

<script>
import axios from 'axios'
var CONFIG = require('@/common/config.js')
var base_url = CONFIG.API_URL.BASE_URL
var img_url = CONFIG.API_URL.IMG_URL
export default {
  data () {
    return {
      type: 1,
      cateIndex: 0,
      itemIndex: 0,
      iconshow: 0,
      isicon: 0,
      showcontent: 1000,
      headImg: '../../static/images/join.png',
      cateInfo: [
        {
          id: 0,
          catename: '查看全部'
        },
        {
          id: 32,
          catename: '技术团队'
        },
        {
          id: 35,
          catename: '产品团队'
        },
        {
          id: 36,
          catename: '销售团队'
        },
        {
          id: 37,
          catename: '专业服务'
        }
      ],
      positionInfo: []
    }
  },
  created: function () {
    	var that = this
    that.getJobList(0, that.type)
  },
  methods: {
    // 切换类型
    changeType: function (type) {
      var that = this
      that.type = type
      that.getJobList(0, type)
    },
    changeCate ($event) {
        this.cateIndex = $event.target.dataset.index
        this.itemIndex = $event.target.dataset.id
        this.getJobList($event.target.dataset.id, this.type)
      // if ($event.target.dataset.id == 0) {
      //   for (var i = 0; i < $event.currentTarget.parentElement.nextElementSibling.childNodes.length; i++) {
      //     if($event.currentTarget.parentElement.nextElementSibling.childNodes[i].className == 'right-cate') {
      //       console.log($event.currentTarget.parentElement.nextElementSibling.childNodes[i].className)
      //       $event.currentTarget.parentElement.nextElementSibling.childNodes[i].className = 'right-cate is-cate'
      //     }
      //   }
      // }else {
      //   for (var i = 0; i < $event.currentTarget.parentElement.nextElementSibling.childNodes.length; i++) {
      //     if($event.currentTarget.parentElement.nextElementSibling.childNodes[i].className == 'right-cate is-cate'){
      //       $event.currentTarget.parentElement.nextElementSibling.childNodes[i].className = 'right-cate'
      //     }
      //   }
      // }

    },
    changicon ($event) {
      // var id = $event.target.dataset.id
      if (this.iconshow == 1) {
        if($event.currentTarget.previousElementSibling){
          $event.currentTarget.className = 'iconfont'
          $event.currentTarget.previousElementSibling.className = 'iconfont is-show'
        }
      } else {
        if($event.currentTarget.nextElementSibling){
          $event.currentTarget.className = 'iconfont'
          $event.currentTarget.nextElementSibling.className = 'iconfont is-show'
        }
      }
      if (this.iconshow == 1) {
        this.iconshow = 0
      } else {
        this.iconshow = 1
      }
      if (this.iconshow == 1) {
        this.showcontent = $event.target.dataset.index
      } else {
        this.showcontent = 1000
      }
    },
    getJobList (cid,type) {
      var that = this
      axios.post(base_url + 'front/getJobById', {'cateId': cid, 'type': type}).then(function (res) {
        if (res.data.code == 0) {
          let positionArr = []
          for(var i=0;i < res.data.result.length;i++){
            let jobinfo = []
            jobinfo['cateid'] = res.data.result[i]['cateId']
            jobinfo['city'] = res.data.result[i]['city']
            jobinfo['jobInfo'] = res.data.result[i]['jobInfo']
            jobinfo['name'] = res.data.result[i]['jobName']
            jobinfo['id'] = res.data.result[i]['id']
            positionArr.push(jobinfo)
          }
          that.positionInfo = positionArr
        }
      }).catch(function (err) {
        // console.log(err);
      })
    },
    /**
       * 提交
       */
    submit: function () {
      axios.post(base_url + 'front/addRecruit', data).then(function (res) {
        if (res.data.code == 0) {

        }
      }).catch(function (err) {
        // console.log(err);
      })
    }

  }
}
</script>

<style scoped>
  @import url("./join.css");
  @import "../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/views/join/join.vue